<h2 mat-dialog-title class="text-center">{{heading}}</h2>
<mat-dialog-content class="mat-typography text-center">
  <p>{{content}}</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button color="warn" (click)="this.matDialogRef.close(true)">{{actionText}}</button>
</mat-dialog-actions>